import { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

import { IrPage, IrPageProps } from '@/components/pages/Ir'

type IrProps = IrPageProps
const Ir = ({ irFinancialEvent, monthlySales,irCalendar }: IrProps) => {
  return (
    <IrPage irFinancialEvent={irFinancialEvent} monthlySales={monthlySales} irCalendar={irCalendar}/>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()
  const [irTop] = await Promise.all([client.fetchIrTop()])
  const irFinancialEvent = irTop?.financialEvent
  const monthlySales = irTop?.monthlySales
  const irCalendar = await client.fetchIrCalendar()
  return {
    props: {
      irFinancialEvent,
      monthlySales,
      irCalendar
    },
  }
}

export default Ir
